import { FileSourceEnum as e } from "../libs/types/dist/index5.mjs";
const i = {
  [e.Editor]: "file_manager.file_source.editor",
  [e.Community]: "file_manager.file_source.community",
  [e.BlockPreview]: "file_manager.file_source.block_preview",
  [e.Membership]: "file_manager.file_source.membership",
  [e.Marketplace]: "file_manager.file_source.marketplace",
  [e.Settings]: "file_manager.file_source.settings",
  [e.Email]: "file_manager.file_source.email",
  [e.Ckeditor]: "file_manager.file_source.ckeditor",
  [e.BlogPost]: "file_manager.file_source.blog_post",
  [e.PageTemplate]: "file_manager.file_source.page_template",
  [e.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [e.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [e.EmailTemplate]: "file_manager.file_source.email_template",
  [e.Product]: "file_manager.file_source.product",
  [e.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [e.DigitalStore]: "file_manager.file_source.digital_store",
  [e.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [e.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [e.FileManager]: "file_manager.file_source.file_manager",
  [e.TextEditor]: "file_manager.file_source.text_editor",
  [e.WhiteLabel]: "file_manager.file_source.white_label",
  [e.WebsiteTemplate]: "file_manager.file_source.website_template"
};
export {
  e as FileSourceEnum,
  i as FileSourceEnumLocoKeys
};
